import { render, staticRenderFns } from "./GoogleFontInput.vue?vue&type=template&id=84b7c4ce"
import script from "./GoogleFontInput.vue?vue&type=script&lang=js"
export * from "./GoogleFontInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports